module.exports = __webpack_public_path__ + "img/new_orleans1.218648bf.jpg";